<div class="container" *ngIf="!quoteShow">
  <!-- JobCard Info -->

    <!-- <div class="details" >
    <div class="logo-and-model">
      <img [src]="getMakeImageUrl(requestDetails?.spareRequest?.make)" alt="Icon" class="img">
      <div class="model-info">
        <span class="model-name">{{requestDetails?.spareRequest?.make}}</span>
        <span class="model-details">{{requestDetails?.spareRequest?.model}}, {{requestDetails?.spareRequest?.fuelType}}</span>
      </div>
    </div>
    <div class="timestamp">{{requestDetails?.spareRequest?.created | date:'dd MMM yyyy, hh:mm a': 'GMT+1060'}}
         </div>
    
  </div> -->
  <!-- <div class="buttons" >
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'requests'}"
            (click)="setActiveTab('requests')">REQUESTS</button>
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'quote-received'}"
            (click)="setActiveTab('quote-received')">QUOTE RECEIVED </button>
    <button class="request-button" 
            [ngClass]="{'active': activeTab === 'quote-approved'}"
            (click)="setActiveTab('quote-approved')">QUOTE APPROVED</button>
    <button class="request-button" 
            *ngIf="filteredOrderList?.length>0"
            [ngClass]="{'active': activeTab === 'order-created'}"
            (click)="setActiveTab('order-created')">ORDER CREATED</button>
  </div> -->

<div class="buttons" *ngIf="isJobCardDetails">
  <button class="request-button" 
          [ngClass]="{'active': activeTabs === 'Information'}"
          (click)="setActiveTabs('Information')">INFORMATION</button>
  <button class="request-button" 
          [ngClass]="{'active': activeTabs === 'Check-in'}"
          (click)="setActiveTabs('Check-in')">CHECK-IN </button>
  <button class="request-button" 
          [ngClass]="{'active': activeTabs === 'images'}"
          (click)="setActiveTabs('images')">IMAGES</button>
  <button class="request-button" 
          [ngClass]="{'active': activeTabs === 'request'}"
          (click)="setActiveTabs('request')">REQUEST</button>  
  <button class="request-button" 
          [ngClass]="{'active': activeTabs === 'quotation'}"
          (click)="setActiveTabs('quotation')">QUOTATION</button>
  <button class="request-button" 
          [ngClass]="{'active': activeTabs === 'invoice'}"
          (click)="setActiveTabs('invoice')">INVOICE</button>
  <button class="request-button" 
          *ngIf="request?.isAmountPaid"
          [ngClass]="{'active': activeTabs === 'payment'}"
          (click)="setActiveTabs('payment')">PAYMENTS</button>

</div>

<!-- Information Tab body -->
<div *ngIf="activeTabs === 'Information' && isJobCardDetails && data">
  <div class="header car-details">
      <h3 style="font-size: 20px;">Information</h3>
  </div>
  <div class="info-div" >
     <div class="car-details">
      <h3>Car Details 🚗</h3>
      <form>
        <div class="form-group">
          <label>Engine Number</label>
          <input
            type="text"
            id="engineNumber"
            [(ngModel)]="formData.engineNumber"
            placeholder="{{data?.engineNumber || 'Enter Engine Number' }}"
            name="engineNumber"
            required
          />
        </div>
        <div class="form-group">
          <label for="odometerReading">
            Odometer Reading<span class="required">*</span>

          </label>
          <input
          type="text"
          placeholder="{{ data?.odometer || 'Enter Odometer Reading' }}"
          name="odometerReading"
          required
          id="odometerReading"
          class="custom-placeholder"
          [(ngModel)]="formData.odometer"
        />
        
        </div>
                  
        <div class="form-group">
          <label for="date">Service Date</label>
          <input
              type="date"
              id="last-service-date"
              name="lastServiceDate"
              [(ngModel)]="formData.lastServiceDate"
            />
        </div>

        <!-- <mat-form-field appearance="outline">
          <mat-label>Last Service Date</mat-label>
          <input matInput [matDatepicker]="picker"  />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field> -->


        <div class="form-group">
          <label for="services">Services Type</label>
          <div class="dropdown-container" (click)="toggleDropdown()">
            <input type="text" placeholder="Select Services*"style="border: 1px solid #dddddd;" readonly />
            <mat-icon style="top: -39px; position: relative;margin-left: 91%;">keyboard_arrow_down</mat-icon>
       
          </div>
          <div *ngIf="car.selectedServices.length > 0" style="margin-top:-21px">
            <div class="chips-container">
              <div class="chip" *ngFor="let service of car.selectedServices">
                {{ service }}
                <span class="close-icon" (click)="removeService(service)">×</span>
              </div>
            </div>
          </div>
          <div class="dropdoencompleteitems"  *ngIf="isDropdownOpen">
            <div class="dropdown-options" id="dropdownOptions">
              <div *ngFor="let service of serviceList" class="dropdown-item" >
                <label>
                 
                  <div class="dropdownitemnames" style="width:95%;">{{ service }}</div>
                  <input
                  style="width:5%;"
                    type="checkbox"
                    [checked]="car.selectedServices.includes(service)"
                    (change)="selectService(service, $event)"
                  />
                </label>
              </div>
            </div>
          </div>

          
        </div>
      </form>
    </div>
    <!-- <div *ngIf="errorMessage" class="error-message-new">
      {{ errorMessage }}
    </div> -->
       <div class="car-details">
      <div class="customerdetailsandicon">
        <h3>Customer Details</h3>
        <mat-icon class="customer-maticon">person_outline</mat-icon>
      </div>
      <form>
        <div class="form-group">
          <label for="customerName">Customer Name</label>
          <input
            type="text"
            placeholder="{{data?.customerName || 'Enter Customer Name'}}"
            name="customerName"
            [(ngModel)]="formData.customerName"
            required
          />
        </div>
        <div class="form-group">
          <label for="customerPhone">Phone Number</label>
          <input
            type="text"
            [(ngModel)]="formData.customerMobile"
            placeholder="{{data?.customerMobile || 'Enter Phone Number'}}"
            name="customerMobile"
            required
          />
        </div>
        <div class="form-group">
          <label >Email ID</label>
          <input
            type="email"
            [(ngModel)]="formData.customerEmail"
            placeholder="{{data?.customerEmail || 'Enter Email ID'}}"
            name="customerEmail"
          />
        </div>
      </form>
      
    </div> 

    <div  class="fuel-accessories-container">
      <div class="car-details">
        <h3 >Fuel Level</h3>
      </div>
       <div class="fuel-level-section">
        <p>Fuel Level: {{ data?.fuelLevel }}%</p>
        <div >
          <span>E</span>
          <input
            type="range"
            min="0"
            max="100"
            [(ngModel)]="data.fuelLevel"
            (ngModelChange)="updateFuelLevel($event)"
          />
          <span>F</span>
        </div>
      </div>
    
      <div class="accessories-section">
        <div class="car-details">
          <h3 >Accessories</h3>
        </div>
        <ul>
          <li *ngFor="let accessory of accessories">
            <img [src]="accessory.imageUrl" [alt]="accessory.description" />
            <label>
              {{ accessory.description }}
             <input
                type="checkbox"
                [checked]="fuelAndAccessories.checkedItems.includes(accessory.description)"
                (change)="selectAccessory(accessory.description, $event)"
              />
            </label>
          </li>
        </ul>
      </div>
    </div>
    <hr>
    <!-- --------------------ISSUES SECTION---------------- -->
     <div class="issues-section">
      <div class="issues-header">
        <div style="display: flex;">
          <mat-icon class="warning-maticon">warning</mat-icon>
          <h3>Do you have more issues?</h3>
        </div>
        <p style="color: #888;">
          Please mention any symptoms (issues) you have noticed in your car. This
          will help our technician to diagnose better.
        </p>
      </div>
      <div class="SearchBarContainer" (click)="toggleSearch()">
        <div class="SearchBarButton">
          <div class="SearchBarIcon">
            <i class="material-icons-search">search</i>
          </div>
          <input  type="text" placeholder="Search Your Issues"  [(ngModel)]="searchText" (input)="filterIssues()" (keydown.enter)="addTag()" class="SearchBarInput"    /> 
          <div class="remove-search-suggestion" *ngIf="filteredIssues"(click)="clearSearch1()" >
            <mat-icon>close</mat-icon>
          </div>             
      </div>
      </div>
      <div *ngIf="selectedIssues.length > 0" >
        <div  class="issue-chips-container">
          <div class="chip" *ngFor="let issue of selectedIssues">
            {{ issue }}
            <span class="close-icon" (click)="removeIssue(issue)">×</span>
          </div>
        </div>
      </div>
      <div class="issues-section" *ngIf="searchText?.length > 0 && filteredIssues.length > 0">
        <ul>
          <li *ngFor="let issue of filteredIssues" [ngClass]="{ 'highlighted-item': issue.isHighlighted }">
            <label [innerHTML]="highlightMatch(issue, searchText)"></label>
            <input
              type="checkbox"
              [checked]="selectedIssues.includes(issue)"
              (change)="toggleIssue(issue, $event)"
            />
            {{ issue.description }}
          </li>
        </ul>
      </div>
   
        
      <!-- </div> -->
      <!-- <div class="classnext">
        <button class="create-order-btn" (click)="saveIssue()" >NEXT</button>
      </div> -->
    </div>
    <button class="updateInfo" (click)="checkInUpdate()">Update Information</button>
</div>
</div>

<!-- Check-in Tab body -->

<div *ngIf="activeTabs === 'images'" >
  <div class="header">
    <!-- <span style="width: 100%; display: contents;"> -->
    <p class="addImage" >Add Images</p>
    <!-- SHARE IMAGES BUTTON -->
     <div class="buttonShare" >
    <button style="display: flex;" class="share-image-btn" (click)="shareImages()">
      <i class="material-icons" style="color: #144579;font-size: 21px; margin-top: 4px;">share</i>
      <p style="margin: 0px; padding: 8px;" *ngIf="!isMobile">SHARE IMAGES</p>
    </button>
    <!-- ADD IMAGES BUTTON -->
    <button class="add-image-btn"  (click)="openImageUpload()">
      <i style="font-size: 20px;padding: 2px;" class="camera_alt">camera_alt</i>
      <p style="margin-top: 7px;margin-bottom: 6px;color: #144579;" *ngIf="!isMobile">ADD IMAGES</p>
    </button>
  </div>
  <!-- </span> -->
  <div class="popup" *ngIf="isUploading">
    <div class="popup-content">
      <div >
        <button mat-icon-button (click)="closeBottomSheet()" class="matClose">
          <mat-icon >close</mat-icon>
        </button>
        <h3 style="margin-left: -122px;margin-top: -26px;">Enter Image Tag </h3>
        <input type="text" [(ngModel)]="newTag" (ngModelChange)="onTagChange()" placeholder="Add a tag for images" class="newTag">
         <div *ngIf="tagError" class="error-text">Enter an image tag</div>
      </div>
      <input type="file" accept="image/*" (change)="onFileChange($event)"  class="inputFile">
      <div *ngIf="imageError" class="error-text">Please select an image</div>

      <button (click)="uploadImages()" class="uploadBtn">Upload</button>
    </div>
  </div>
  </div>
<div class="imageDiv" >
  <div class="add-images-container">
    <!-- Title and Add Image Button -->
    <!-- <div class="image-upload-section" *ngIf="isUploading">
      <input type="file" (change)="onFileChange($event)" multiple>
      <input type="text" [(ngModel)]="newTag" placeholder="Add a tag for images">
      <button (click)="uploadImages()" class="uploadBtn">Upload</button>
    </div> -->
    <!-- Image Preview Section -->
    <div class="image-section">
      <div class="image-grid">
        <!-- Loop through additional uploaded images -->
        <div *ngFor="let image of additionalImages">
          <div *ngIf="additionalImages.length > 0" style="margin-top: -27px;">
            <i class="material-icons cancelBtn" (click)="removeImage(image.tag)">cancel</i>
          </div>
          <div class="image-item">
            <input *ngIf="additionalImages.length > 0" class="input-checkbox"
            type="checkbox" [(ngModel)]="selectedImages[image.url]" />
            <div class="image-box" (click)="openImageViewer(image)">
              <img [src]="image.url" [alt]="image.tag" class="insideImage" />
            </div>
            <span class="image-gridtext">{{ image.tag }}</span>
            <!-- <span class="image-gridtext">{{ image.tag === 'fuel_meter' ? 'Fuel Level' : image.tag }}</span> -->

          </div>
        </div>
        <div *ngFor="let tag of getMissingTags()">
           <div *ngIf="!(getImage(tag))">
            <div class="image-item" >
              <!-- <input *ngIf="getImage(tag)" class="input-checkbox" type="checkbox" [(ngModel)]="selectedImages[tag]" /> -->
              <div class="image-box" (click)="handleImageClick(tag)">
                <input                 
                [id]="tag + 'FileInput'"
                type="file"
                accept="image/*"
                style="display: none"
                (change)="onImageSelected(tag, $event)"
              />
                <ng-container *ngIf="getImage(tag); else defaultIcon">
                  <img [src]="getImage(tag)" [alt]="tag" class="insideImage" />
                </ng-container>
                <ng-template #defaultIcon>
                  <mat-icon>image</mat-icon>
                </ng-template>
              </div>
              <span class="image-gridtext">{{ tag | titlecase }}</span>
            </div>
          </div>
        </div>
<div class="image-viewer" *ngIf="isViewerOpen1">
  <div class="image-container">
    <button class="prev-btn-quote" (click)="prevImage()">&#10094;</button>

    <img [src]="viewerImages[currentIndex]?.url" class="full-image" alt="{{ viewerImages[currentIndex]?.tag }}" />

    <div class="image-tag-popup">{{ viewerImages[currentIndex]?.tag | titlecase }}</div>

    <button class="next-btn-quote" (click)="nextImage()">&#10095;</button>

    <button class="close-btn-quote" (click)="closeViewer()">✖</button>
  </div>
</div>
  <!-- <div class="image-viewer" *ngIf="isViewerOpen">
      <div class="image-container">
        <button class="prev-btn" (click)="prevImage()" style="position: fixed;left: 127px;">&#10094;</button> 
        
        <img [src]="getImage(tag)" class="full-image">
        <div class="image-tag-popup">{{ images[currentIndex]?.tag }}</div>
    
        <button class="next-btn1" (click)="nextImage()">&#10095;</button>
    
        <button class="close-btn" (click)="closeViewer()">✖</button>
      </div>
    </div> -->
    

<!-- Loop through additional uploaded images -->
<!-- <div *ngFor="let image of additionalImages">
  <div *ngIf="additionalImages.length > 0" style="margin-top: -27px;">
    <i class="material-icons cancelBtn" (click)="removeImage(image.tag)">cancel</i>
  </div>
  <div class="image-item">
    <input  class="input-checkbox"
    type="checkbox" [(ngModel)]="selectedImages[image.url]" />
    <div class="image-box" (click)="triggerFileInput(image.tag)">
      <img [src]="image.url" [alt]="image.tag" class="insideImage" />
    </div>
   
    <span class="image-gridtext">{{ image.tag === 'fuel_meter' ? 'Fuel Level' : image.tag }}</span>


<div class="image-viewer" *ngIf="isViewerOpen" >
  <div class="image-container">
    <button class="prev-btn-quote" (click)="prevImage()">&#10094;</button>
    <img [src]="getImagesForTag(currentTag)[currentIndex]" class="full-image">
    <div class="image-tag-popup">{{ currentTag | titlecase }}</div>
    <button class="next-btn-quote" (click)="nextImage()">&#10095;</button>
    <button class="close-btn-quote" (click)="closeViewer()">✖</button>
  </div>
</div>
       </div>
      <input *ngFor="let tag of ['front', 'engine', 'battery', 'right', 'back', 'left', 'fuel']"
      
        [id]="tag + 'FileInput'"
        type="file"
        accept="image/*"
        style="display: none"
        (change)="onImageSelected(tag, $event)"
      />
    </div> -->
    
    
    <!-- <div class="image-previews">
      <div *ngFor="let image of images; let i = index" class="image-item">
        <div>
          <img [src]="image.url" alt="Image Preview" class="image-preview" (click)="openImageViewer(i)">
          <i class="material-icons cancelBtn" (click)="removeImage(i)">cancel</i>
        </div>
        <div>
          <span class="image-tag">{{ image.tag }}</span>
        </div>
      </div>
    </div> -->
    
    <!-- Fullscreen Image Viewer (Modal) -->
    <!-- <div class="image-viewer" *ngIf="isViewerOpen">
      <div class="image-container">
        <button class="prev-btn" (click)="prevImage()" style="position: fixed;left: 127px;">&#10094;</button> 
        
        <img [src]="getImage(tag)" class="full-image">
        <div class="image-tag-popup">{{ images[currentIndex]?.tag }}</div>
    
        <button class="next-btn1" (click)="nextImage()">&#10095;</button>
    
        <button class="close-btn" (click)="closeViewer()">✖</button>
      </div>
    </div> -->
    
    
  
    <!-- Upload Section (hidden by default) -->

  </div>
</div>
</div>
</div>
</div>
<div *ngIf="activeTabs === 'Check-in'">
  <app-asp-checkin-reports (changeTab)="setActiveTabs($event)" [bookingId]="jobCard['bookingId']" 
  [jobCard]="jobCard['id']" [jobCardStatus]="jobCard['jobcardStatus']" ></app-asp-checkin-reports>
 
</div>
<div *ngIf="activeTabs === 'payment'">
  <div class="main-content" *ngFor="let item of filteredPaymentListData">
    <div class="second-main">
        <div class="order-header">
            <div class="order-status" style="width: 76%;">Payment ID # {{ item.paymentId || 'N/A' }}</div>
            <div class="status-badge">
                {{ item.paymentStatus == 1 ? 'Paid' : item.paymentStatus == 2 ? 'Partially Paid' : 'Pending' }}
            </div>                
            
        </div>
        <div class="order-details">
            <p class="order-number">Invoice No # {{ item.invoiceId || 'N/A' }}</p>
            <p class="total-amount" style="color: black;">Job Card # {{ item.jobCardId || 'N/A' }}</p>
            <div class="vehicle-details">
                <div class="logo-container">
                    <img [src]="'https://cube.getpitstop.com/assets/img/' + (item.make ? item.make.toLowerCase().replace(' ', '') : 'N/A') + '.png'" 
                        alt="Make Image" class="car-icon" />
                </div>
                <div class="vhclnameandinfo">
                    <div class="vehicle-name"><strong>{{ item.model || 'N/A' }}, {{ item.fuelType || 'N/A' }}</strong></div>
                    <div class="vehicle-info">{{ item.variant || 'N/A' }} [{{ item.year || 'N/A' }}]</div>
                    <div class="vehicle-regNo">{{ item.registrationNumber || 'N/A' }}</div>
                    <div class="vehicle-regNo">{{ item.vinNumber || 'N/A' }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="amountpaid-amountdue">
        <div class="item-list" style="margin-top: 0px;">Total Amount Paid: ₹{{ item.amountPaid || 'N/A' }}</div>
        <div class="amount-due" *ngIf="item.paymentStatus == 2">
            Total Amount Due: ₹{{ (item.amountDue) | number:'1.2-2' || 'N/A' }}
          </div>
        </div>

    <div class="dateandview">
        <div class="placed-date">Paid on: {{ item.paymentDate || 'N/A' }}</div>
        <button class="Viewbtn" (click)="openRecordPaymentSidebar(item.paymentId,item.jobCardId)">
            <span class="view" >View Details</span>
            <i class="material-icons">arrow_right</i> 
        </button>           
    </div>
    
  </div>
</div>

<!-- <div *ngIf="activeTabs === 'quotation' && QuoteId">
  <app-asp-customer-quote 
  [QuoteId]="QuoteId" 
  [jobcardId]="jobcardId1"
  >
</app-asp-customer-quote> 
</div> -->
<div class="third-div" [hidden]="(activeTabs === 'invoice' && invoice)"  >
  <div #invoiceTab></div>
</div>
<div class="third-div" [hidden]="!(activeTabs === 'invoice' && invoice)">
  <div #invoiceContainer></div>
</div>
<!-- <div class="third-div" [hidden]="!(activeTabs === 'quotation' && QuoteId)">
  <div #dynamicContainer1></div>
</div> -->
<!-- Content for Quote Recieve Tab -->
<div *ngIf="activeTabs === 'quotation' || isRequestDetails" >
  <div *ngIf="activeTab === 'quote-received'">
    <div *ngIf="quotationreceived.length > 0" class="items" style="    margin-bottom: 78px;">
      <div class="request-info">Quote received for {{quotationreceived.length}} items </div>
      <div class="item" >
        <div class="checkboxselect">
          <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
          <span >Select All</span>
        </div>
        <div>
          <span class="quote-rcvd-prz">₹ {{quoteReceivedPrice | number:'1.2-2'}}</span>
          <div class="total-slng-prz"> Total Selling Price  </div>
        </div>
      </div>
      <div class="quotereceived-items" *ngFor="let item of quotationreceived" [ngClass]="{'border-box': item.selected}">
        <div class="checkboxselect">
          <div class="lines" >
            <input type="checkbox" [(ngModel)]="item.selected" (change)="toggleItemSelection()">
            <span class="part-name" >{{item.itemName}}</span>
            <span class="ellipsis" (click)="openSidebar(item)" style="margin-top: -4px;">⋮</span>
          </div>
      
          <div class="lines" >
            <!-- <span class="availability"> Availability: </span> -->
            <span class="date">₹{{(item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity | number:'1.2-2'}}</span>

          </div>
        </div>
        <div class="lines">
          <span class="date-time" style="margin-left: 18px;">{{item.edt  | date:'dd MMM yyyy'}}</span>
         
        </div>
      </div>
    </div>

    <!-- <ng-template #noQuotesReceived >
      <div>
        <div class="empty-state">
          <div  *ngIf="isQuoteApproved(); else notApproved">
            <img src="../../../../assets/images/request-details images/requestdetailsimages.png" alt="Quote Approved" class="quote-image">
            <div  class="message">
              <strong >Quote Has Been Approved!</strong>
              <p>Check Quote Approved Section</p>
            </div>
          </div>
        </div>
        <ng-template #notApproved>
          <div class="empty-state"  *ngIf="quotationreceived.length === 0">
            <img src="../../../../assets/images/request-details images/requestdetailsimage.png" alt="Quote Not Created" class="quote-image">
            <div class="message">
              <strong>Quote Not Created Yet!</strong>
              <p>Stay tuned for updates</p>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-template> -->
  </div>

  <!-- <div class="third-div" > -->
    <!-- <div class="overlay" [class.visible]="activeTabs === 'quotation'" (click)="closeSidebar1()" *ngIf="activeTabs === 'quotation'"></div> -->
  <!-- <div class="sidebar1" *ngIf="activeTabs === 'quotation'">
    <div class="sidebar-header">
      <span class="sidebar-title" >Quotation Details</span>
      <span class="close-btn" (click)="closeSidebar1()">&times;</span>
    </div>

    
    <div class="buttons">
      <button class="request-button" 
              [ngClass]="{'active': activeTab === 'quote-received'}"
              (click)="setActiveTab('quote-received')">QUOTE RECEIVED</button>
      <button class="request-button" 
              [ngClass]="{'active': 
              }"
              (click)="setActiveTab('quote-approved')">QUOTE APPROVED</button>
    </div>

      

  
      <div *ngIf="activeTab === 'quote-approved'">
        <div *ngIf="quotationapproved.length > 0; else noQuotesApproved" class="items">
          <div class="request-info"> Quote approved  for {{quotationapproved.length}} items </div>
          <div class="total-selling-price">
            <span>Total Selling Price</span>
            <span class="total-price">₹ {{quoteApprovedPrice | number:'1.2-2'}} </span>
          </div>
        
          <div class="quoteaproved-items" *ngFor="let item of quotationapproved" [ngClass]="{'border-box': item.selected}">
            <div class="line" >
              <span class="part-name">{{item.itemName}}</span>
              <span class="ellipsis" (click)="openSidebar(item)">⋮</span>
            </div>
            <div class="line">
              <span class="availability">Availability</span>
              <span class="date">₹{{(item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity}}</span>
            </div>
            <div class="line">
              <span class="date-time">{{item.edt  | date:'dd MMM yyyy'}}</span>
              <span class="amount">Total Selling Price</span>
          </div> 
        </div>  
      </div>
      <ng-template #noQuotesApproved>
        <div class="empty-state">
          <div >
            
            <img src="../../../../assets/images/request-details images/requestdetailsimage.png" alt="Quote Not Approved" class="quote-image">
            <div class="message">
              <strong>Quote Not Approved Yet!</strong>
              <p>Awaiting your approval</p>
            </div>
          </div>
        </div>
        <button class="approveNow">APPROVE QUOTE NOW</button>
      </ng-template>
    </div>
  </div> -->


    <!-- <div style="font-weight: 900;font-size: larger; padding: 10px 0;border-bottom: 1px solid #ddd;" class="request-info" *ngIf="activeTab !== 'quote-received' ">
      <strong>Request made for {{requestDetails.spareRequestItemList.length}} items </strong>
       <hr /> 
    </div> -->

    <div *ngIf="isRequestDetails && isJobCardDetails && activeTab === 'requests'" class="request-item">
      <div class="request-info">Request made for {{requestDetails?.spareRequestItemList?.length}} items </div>
      <div class="item" *ngFor="let item of requestDetails?.spareRequestItemList">
        <span class="span-item-name">{{item.itemName}}</span>
        <span class="quantity">{{item.itemQuantity}} Unit</span>
      </div>
    </div>
    <!-- <hr /> -->
     <!-- sidebarOpenQuote -->

    <!-- Content for Quote Received Tab -->
    <div *ngIf="activeTab === 'quote-received' && isRequestDetails && sidebarOpenQuote">   
      <div *ngIf="quotationreceived.length > 0; else noQuotesReceived" class="items" style="margin-bottom: 88px;">
        <div class="request-info">Quote received for {{quotationreceived.length}} items </div>
        <div class="item" >
          <div class="checkboxselect">
            <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()">
            <span >Select All</span>
          </div>
          <div>
            <span class="quote-rcvd-prz">₹ {{quoteReceivedPrice | number:'1.2-2'}}</span>
            <div class="total-slng-prz"> Total Selling Price  </div>
          </div>
        </div>
        <div class="quotereceived-items" *ngFor="let item of quotationreceived" [ngClass]="{'border-box': item.selected}">
          <div class="checkboxselect">
            <div class="lines" >
              <input type="checkbox" [(ngModel)]="item.selected" (change)="toggleItemSelection()">
              <span class="part-name" >{{item.itemName}}</span>
              <span class="ellipsis" (click)="openSidebar(item)" >⋮</span>
            </div>
        
            <div class="lines" style="margin-left: 1104px;">
              <span class="availability"> Availability: </span>
              <span class="date">₹{{(item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity | number:'1.2-2'}}</span>
  
            </div>
          </div>
          <div class="lines">
            <span class="date-time" >{{item.edt  | date:'dd MMM yyyy'}}</span>
           
          </div>
        </div>
      </div>
        <div class="quotereceived-items" *ngFor="let quote of selectedItemsLabourQuote" [ngClass]="{'border-box': quote.selected}">
          <div class="checkboxselect">
            <input 
              type="checkbox" 
              [(ngModel)]="quote.selected" 
              (change)="onLabourSelectionChange(quote)"
            />
            <span class="part-name">{{ quote.labourName }}</span>
            <span class="date">₹{{ quote.labourAmount | number: '1.2-2' }}</span>
            <i class="material-icons" (click)="openLabourEditSidebar(quote)">edit</i>
          </div>
        </div>
        
      </div>
      <!-- Template for No Quotes Received -->
       <ng-template #noQuotesReceived >
        <div>
          <div class="empty-state">
            <div  *ngIf="isQuoteApproved(); else notApproved">
              <img src="../../../../assets/images/request-details images/requestdetailsimages.png" alt="Quote Approved" class="quote-image">
              <div  class="message">
                <strong >Quote Has Been Approved!</strong>
                <p>Check Quote Approved Section</p>
              </div>
            </div>
          </div>
          <ng-template #notApproved>
            <div class="empty-state"  *ngIf="quotationreceived.length === 0">
              <img src="../../../../assets/images/request-details images/requestdetailsimage.png" alt="Quote Not Created" class="quote-image">
              <div class="message">
                <strong>Quote Not Created Yet!</strong>
                <p>Create Customer Quotation.</p>
              </div>
            </div>
          </ng-template>
        </div>
      </ng-template> 
    </div>
    <!-- Content for Quote Approved Tab (under quote approved tab)-->
    <div *ngIf="activeTab === 'quote-approved' && isRequestDetails">
      <div *ngIf="quotationapproved.length > 0; else noQuotesApproved" class="items">
        <div class="request-info"> Quote approved for {{quotationapproved.length}} items </div>
        <div class="checkboxselect-approved">
          <input type="checkbox" [checked]="selectAll" (change)="ApprovedtoggleSelectAll()">
          <span style="margin-left: 21px;">Select All</span>
        </div>
        <div class="total-selling-price">
          <span>Total Selling Price</span>
          <span class="total-price">₹ {{quoteApprovedPrice | number:'1.2-2'}} </span>
        </div>

        <!-- <hr class="divider"> -->
        <div class="quoteaproved-items" *ngFor="let item of quotationapproved" [ngClass]="{'border-box': item.selected}">
          <!-- {{item.quoteItemStatus}} -->
           <div class="status-tag-ellips">
            <span class="ellipsis" (click)="openSidebar(item)">⋮</span>
          <!-- <div class="approved-pending-tag" *ngIf="item.quoteItemStatus== 2">
            <mat-icon class="hourglass-icon">hourglass_full</mat-icon>
            Pending
          </div>
          <div class="approved-completed-tag" *ngIf="item.quoteItemStatus == 1">
            <mat-icon class="thumb-icon">thumb_up</mat-icon>
            Completed
          </div> -->
         
        </div>
          <div class="line" >
            <input type="checkbox" [(ngModel)]="item.selected" (change)="ApprovedtoggleItemSelection()">
            <span class="part-name">{{item.itemName}}</span>
           
          </div>
          <div class="line-mrp" style="text-align: end;">
            <!-- <span class="availability">Availability</span> -->
            <span class="date">₹{{(item.mrp - (item.mrp* item.sellingDiscount /100))*item.itemQuantity}}</span>
          </div>
          <div class="line">
            <span class="date-time" style="margin-left: 29px;">{{item.edt  | date:'dd MMM yyyy'}}</span>
            <span class="amount">Total Selling Price</span>
        </div> 
      </div>  
    </div>
    <!-- Template for No Quotes Approved -->
    <ng-template #noQuotesApproved>
      <div class="empty-state">
        <div> 
          <img src="../../../../assets/images/request-details images/requestdetailsimage.png" alt="Quote Not Approved" class="quote-image">
          <div class="message">
            <strong>Quote Not Approved Yet!</strong>
            <p>Awaiting your approval</p>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <!-- Sidebar Section -->
  <div class="overlay" [class.visible]="sidebarOpen" (click)="closeSidebar()"></div>
   <div *ngIf='itemDetails' [class.sidebar-open]="sidebarOpen" class="sidebar">
          <div class="sidebar-header" >
            <span class="sidebar-title">{{itemDetails.itemName}}</span>
            <span class="close-btn" (click)="closeSidebar()">&times;</span>
          </div>
          <div class="sidebar-content">
            <div class="sidebar-item">
              <span class="label">Brand</span>
              <span class="value" >{{ itemDetails.brand}}</span>
            </div>
            <div class="sidebar-item">
              <span class="label">Quantity</span>
              <span class="value">{{itemDetails.itemQuantity}}</span>
            </div>
            <div class="sidebar-item">
              <span class="label">Availability</span>
              <span class="value">{{itemDetails.edt  | date:'dd MMM yyyy, hh:mm a'}}</span>
            </div>
            <div class="sidebar-item">
              <span class="label">MRP(Unit)</span>
              <span class="value">₹{{itemDetails.mrp | number:'1.2-2' }}</span>
            </div>
            <div class="sidebar-item" >
              <span class="label">MRP Total</span>
              <span class="value">₹{{itemDetails.mrp * itemDetails.itemQuantity | number:'1.2-2'}}</span>
            </div>
            <div class="sidebar-item">
              <span class="label">Selling Price(Unit)</span>
              <span class="value">₹{{itemDetails.mrp - (itemDetails.mrp* itemDetails.sellingDiscount /100) | number:'1.2-2'}}</span>
            </div>
            <div class="sidebar-item">
              <span class="label">Total Selling Price</span>
              <span class="value">₹{{(itemDetails.mrp - (itemDetails.mrp* itemDetails.sellingDiscount /100)) * itemDetails.itemQuantity | number:'1.2-2' }}</span>
            </div>
            <div class="sidebar-item" >
              <span class="label">Discount</span>
              <span class="value">{{itemDetails.sellingDiscount}} %</span>
            </div>
            <div class="sidebar-item">
              <span class="label">Part Number</span>
              <span class="value">{{itemDetails.partNumber}}</span>
            </div>
          </div>
          <button class="okay-btn" (click)="closeSidebar()">Okay, got it</button>
        </div>
  <!-- Bottom Box for Selected Items -->
  <!-- <div *ngIf="activeTab === 'quote-received' && (activeTabs !== 'quotation' || activeTabs !== 'Information' || activeTabs !== 'Check-in' || activeTabs !== 'invoice')"> -->
  <div *ngIf="activeTab === 'quote-received' && !isJobCardDetails">

    <div *ngIf="selectAll>0 || selectedItemsCount>0" class="bottom-box">
      <div class="bottom-content">
        <div>
          <div class="total-items">selectedItemsCount items</div>

          <div class="total-amount">Total Selling Price ₹{{totalSelectedPrice | number:'1.2-2'}} </div>
        </div>
      </div>
      <!-- <button class="approve-quote-button" (click)="getAllRequestPopup()">Approve Quote</button> -->
      <button class="approve-quote-button" (click)="approveQuote()" class="approve-quote-btn">Approve Quote</button>     
    </div>
  </div>
      <!-- Bottom Box for approved Selected Items -->
      <div *ngIf="activeTab === 'quote-approved'">
        <div *ngIf="selectedApprovedItemsCount>0" class="bottom-box">
          <div class="bottom-content">
            <div>
              <div class="total-items">selectedApprovedItemsCount items</div>
    
              <div class="total-amount">Total Selling Price ₹{{totalSelectedApprovedPrice | number:'1.2-2'}} </div>
            </div>
          </div>
          <!-- <button class="approve-quote-button" (click)="getAllRequestPopup()">Approve Quote</button> -->
          <button class="approve-quote-button" (click)="markAsCompleteUpdate()" class="approve-quote-btn">Mark as Complete</button>
          
               
        </div>
      </div>
</div>

<!-- <div *ngIf="quoteShow">
 <app-asp-customer-quote 
    [QuoteId]="resData.id" 
    [jobcardId]="jobcardId1"
    >
  </app-asp-customer-quote>
</div> -->


 <div *ngIf="activeTab === 'order-created'">
  <div *ngIf="!loading">
    <div *ngFor="let list of filteredOrderList" >
      
      <!-- <div *ngIf="list.requestId== id"> -->
      <div class="header-row0"  *ngIf="list.orderNumber !=null">  
        <div class="header-row">
          <div class="order-icon" style="width: 5%;">
            <i class="material-icons">check_box</i>
          </div>
          <div class="order-info">
            <div class="order-status">
              <h1 *ngIf="list.titleName && list.titleName !== '0 minutes'" >
                Order delivered in {{ list.titleName }}</h1>
                <h1 *ngIf="list.titleName && list.titleName === '0 minutes'">
                  Your order is in progress</h1>
              <div 
                class="delivery-status" 
                [ngClass]="{
                    'delivered-status': list.orderCurrentStatus === 'Delivered',
                    'confirmed-status': list.orderCurrentStatus === 'Confirmed',
                    'packed-status': list.orderCurrentStatus === 'Packed',
                    'on-the-way':list.orderCurrentStatus==='On The Way'}">
                  {{list.orderCurrentStatus}}
              </div>
            </div>
            <div class="request-id"  style="margin-top: 43px;" >Order No# {{list.orderNumber}}</div>
            <div class="request-id" *ngIf="list.requestId !== 0">Request ID# {{list.requestId}}</div>
            <div class="order-amount">Total Amount - ₹{{list.grandTotal}} </div>
          </div>
        </div>
        <div class="header-row1">
          <div class="order-item"><span *ngFor="let items of list.orderItems; index as i"><span *ngIf="i!=0">,</span> {{items.partName}}</span></div>
        </div>
        <div class="header-row2">
          <div class="order-date">
            <span>Placed on: {{list.createdAt | date: 'dd MMM yyyy'}}, {{list.createdAt | date: 'hh:mm a'}}</span>
            <button (click)="loadorderdetails(list.orderKey)" class="Viewbtn">
              <span class="view">View Details</span>
              <i class="material-icons">arrow_right</i> 
            </button>
          </div>
        </div>
      </div>
    <!-- </div> -->
      </div>
    </div>
</div>
<!-- </div> -->
<div #dynamicContainer></div>

<!-- Edit Dialog and Overlay -->
<div class="overlay1" [class.visible]="isPopupOpenEdit" (click)="closePopupEdit()"></div>
<div *ngIf="isPopupOpenEdit" [ngClass]="isMobile ? 'bottom-sheetMobile' : 'bottom-sheet'">
  <header class="back-button">
    <div style="flex-direction: column;width: 87%;">
      <h3 class="header-name" style="margin-bottom: 2px;margin-top: -2px;">{{ itemQuote.itemName }}</h3>
      <h3 class="header-name" style="margin-bottom: 2px;margin-top: -2px;font-weight:100;font-size:13px">{{ itemQuote.brand }}</h3>
    </div>
    <mat-icon (click)="closePopupEdit()" class="close-pop-up">close</mat-icon>
  </header>
  <div class="bottom-sheet-content">
    <form [formGroup]="unitPrice" class="unit-price">
    <div class="unit-price">
      <mat-form-field appearance="outline" class="full-width" class="edit-labour-details">
        <mat-label>Unit Price</mat-label>
        <input
          matInput
          formControlName="unitprice"                            
          [(ngModel)]="itemQuotesEdit.mrp"
          placeholder="Enter Unit Price*"
          required
          name="Unit Price"
          pattern="^[0-9]*$"
        />
        <mat-error *ngIf="up.unitprice.errors?.required">Unit Price is required</mat-error>
        </mat-form-field>
    </div>
  </form>
  <div class="item-update">
    <button (click)="save()" class="item-update-btn">Save Quote</button>
  </div>
  </div>
</div>
<div *ngIf="activeTabs === 'quotation' && QuoteId">
    <!-- <app-asp-checkin-reports (changeTab)="setActiveTabs($event)" [bookingId]="jobCard['bookingId']" 
    [jobCard]="jobCard['id']"></app-asp-checkin-reports> -->
    <app-asp-customer-quote 
    [QuoteId]="QuoteId" 
    [jobcardId]="jobcardId1"
    >
  </app-asp-customer-quote> 
</div>

<mat-sidenav-container *ngIf="!QuoteId && sidebarOpenQuote">
  <div class="overlay" [class.visible]="sidebarOpenQuote" (click)="CloseSidebarQuote()" ></div>
  <div class="sidebar" [ngClass]="{
    'sidebar-openQuote': sidebarOpenQuote && !isMobile,
    'sidebar-openQuoteMobile': sidebarOpenQuote && isMobile
  }">
  



    <!-- starting creating customer quotation -->
    <mat-list >
        <header>
          <div class="header-title">
          <div class="back-button">
            
            <i (click)="CloseSidebarQuote()" class="material-icons-arrowback" style="margin-right: 10px;">arrow_back</i>
            
            <span class="title1">Create Customer Quote</span>
            <div *ngIf="quoteId">
              <h2>{{ quoteId }}</h2>
            </div>

          </div>
          </div>
        </header>
        <!-- {{newlyUploadedImages}} -->

  
        
        <!-- Image Viewer Popup -->
        <div class="image-viewer" *ngIf="isViewerOpen">
          <div class="image-container">
            <button class="close-btn-quote" (click)="closeViewer()">✖</button>
            <button class="prev-btn-quote" (click)="prevImage1()">&#10094;</button>
            <img [src]="selectedImage" class="full-image">
            <button class="next-btn-quote" (click)="nextImage1()">&#10095;</button>
          </div>
        </div>
        <div class="detailsQuote">
          <div class="logoModel" *ngIf="(isJobCardDetails && requestId) && (newlyUploadedImagesLength == 0 || newlyUploadedImagesLength == '0')">
              <img [src]="getMakeImageUrl(requestDetails?.spareRequest?.make)" alt="Icon" class="img">
              <div class="model-info">
                <span class="model-name">{{requestDetails?.spareRequest?.make}}</span>
                <span class="model-details">{{requestDetails?.spareRequest?.model}}, {{requestDetails?.spareRequest?.fuelType}}</span>
              </div>
          </div>
          <div class="logoModel" *ngIf="(isJobCardDetails && !requestId) && (newlyUploadedImagesLength == 0 || newlyUploadedImagesLength == '0' || newlyUploadedImagesLength == undefined || newlyUploadedImagesLength == null)">
            <img [src]="getMakeImageUrl(request?.jobCard?.make)" alt="Car Make Image" class="img">
            <div class="model-info">
              <span class="model-name">{{ request?.jobCard?.make || 'Unknown Make' }}</span>
              <span class="model-details">{{ request?.jobCard?.model || 'Unknown Model' }}, {{ request?.jobCard?.fuelType || 'Unknown Fuel Type' }}</span>
              <span class="model-details">{{ request?.jobCard?.registrationNumber || '' }}</span>
              <span class="model-details">{{ request?.jobCard?.vinNumber || '' }}</span>
            </div>
          </div>
          <!-- <div class="buttons" *ngIf="activeTabs === 'quotation'">
            <button class="request-button" 
                    [ngClass]="{'active': activeTab === 'quote-received'}"
                    (click)="setActiveTab('quote-received')">QUOTE RECEIVED</button>
            <button class="request-button" 
                    [ngClass]="{'active': activeTab === 'quote-approved'}"
                    (click)="setActiveTab('quote-approved')">QUOTE APPROVED</button>
                    
          </div> -->
          <!-- <mat-divider></mat-divider> -->
          <div *ngIf="customerQuotationCount>=0 else noQuotesReceived">
              <div  class="items" *ngIf="(activeTab === 'quote-received') || (activeTabs==='quotation') ">
                <!-- <div class="request-info">Quote received for {{requestDetails?.spareRequestItemList?.length}} items </div> -->
                <div class="item" >
                  <div class="checkboxselect">
                    <input type="checkbox" [checked]="selectAllQuote" (change)="toggleSelectAllQuote()">
                    <span>Select All</span>
                  </div>
                  <div style="text-align: right;">
                    <span class="customer-quote-price" >₹ {{quoteGrandTotal | number:'1.0-0'}}</span>
                    <div class="quote_total_amount">Total Amount</div>
                  </div>
                </div>
                <div class="spare-part-header">
                <h2 style="font-weight: bold;">Spare Parts</h2>
                <p style="margin-top:23px;color:#144579;cursor:pointer;" (click)="AddItems()" *ngIf="(customerQuotation?.length > 0 && selectedItemsLabourQuote?.length > 0)">Add More</p>
              </div>

                <div class="quotereceived-items" *ngFor="let quote of customerQuotation; let i = index" [ngClass]="{'border-box': quote.selected}">
                  
                  <div class="lines" style="display: flex;">
                    <input class="checkbox-spare" type="checkbox" [(ngModel)]="quote.selected" (change)="sidebarToggleItemSelectionQuote()">
                    <span class="part-name">{{quote.itemName}}</span>
                    <i class="material-icons-spare" style="cursor:pointer;" (click)="openEditDialog(quote)">edit</i>                  
                  </div>

                  <div class="lines-mrp" style="justify-content: space-between; display: flex;">
                    <span class="spare-mrp" style="color: #999; font-size: 13px;">{{quote.partNumber}}</span>
                    <span class="spare-mrp">₹{{quote.mrp * quote.itemQuantity | number:'1.0-0'}}</span> 
                  </div>

                  <hr style="border: 1px solid #ebebeb;" />

                  <div class="quantity-control">
                    <div class="brand">
                      {{quote.brand}}
                    </div>
                    <div class="addtocartcompatiblecar1">
                      <div class="spare-add-cart1">
                        <!-- <div class="btn-group"> -->
                          <button class="button1" mat-raised-button style="font-size: 11px; float: left; width: 25%; min-width: 25%; box-shadow: none; padding: 0; margin: 0; line-height: 36px; border-top-left-radius: 10px; border-bottom-left-radius: 10px;" (click)="decrementjobcardQuantity(quote)">
                            <mat-icon class="sidebuttons1" style="width: 1px; padding: 7px 0px; margin-left: -6px; margin-right: -3px; font-size: 18px; height: 35px; vertical-align: center; color: #144579;">remove</mat-icon>
                          </button>
                          <span class="button1" mat-raised-button style="font-size: 13px; float: left; width: 50%; text-align: center; color: #144579; line-height: 36px;">
                            {{quote.itemQuantity}} 
                          </span>
                          <button class="button1" mat-raised-button style="font-size: 11px; float: left; width: 25%; min-width: 25%; box-shadow: none; padding: 0; margin: 0; line-height: 36px; border-top-right-radius: 10px; border-bottom-right-radius: 10px;" (click)="incrementjobcardQuantity(quote)">
                            <mat-icon class="sidebutton1" style="width: 1px; padding: 7px 0px; margin-left: -6px; margin-right: -3px; font-size: 18px; height: 35px; vertical-align: center; color: #144579;">add</mat-icon>
                          </button>
                          
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>

                  <!-- ==================ITEM LEVEL DISCOUNT============== -->
                  <!-- <form [formGroup]="mainForm">
                      <div formArrayName="quoteFormArray">
                          <div [formGroupName]="i" class="item-level-discount-mat-form">

                             <mat-form-field appearance="outline" class="item-discount-input">
                              <mat-label>Discount %</mat-label>
                              <input
                                matInput
                                type="number"
                                formControlName="discountPercentage"
                                [disabled]="getControlValue(i, 'discountValue')"
                                (input)="calculateItemDiscountPreview(i)"
                              />
                            </mat-form-field>
                            
                            <mat-form-field appearance="outline" class="item-discount-input">
                              <mat-label>Discount ₹</mat-label>
                              <input
                                matInput
                                type="number"
                                formControlName="discountValue"
                                [disabled]="getControlValue(i, 'discountPercentage')"
                                (input)="calculateItemDiscountPreview(i)"
                              />
                            </mat-form-field>

                          </div>

                          <div *ngIf="customerQuotation[i]?.isDiscountInvalid" class="error-text" style="color: red; font-size: 12px;">
                            Discount can't exceed  or 100%
                          </div>
                      </div>    
                  </form> -->
                  <!-- ==================ITEM LEVEL DISCOUNT END============== -->

             
                </div>
              </div>
          
              
              <div class="labour-section-details" *ngIf="selectedItemsLabourQuote?.length>0">
                <div class="labour-header-title">
                  <h2 style="font-weight: bold;">Labour Charges</h2>
                  <p style="margin-top:23px;color:#144579;cursor:pointer;font-weight: bold;" (click)="addLabourSidebar()" >Add More</p>
                </div>
                <div class="quotereceived-items" *ngFor="let quote of selectedItemsLabourQuote" [ngClass]="{'border-box': quote.selected}">
                  <div class="checkboxselect">
                    <div class="labour-lines" style="display:flex">
                      <input type="checkbox" class="checkbox-spare" [(ngModel)]="quote.selected" (change)="totalLabourselectionQuote(quote)">
                      <span class="part-name">{{quote.labourName}}</span>
            
                      <i class="material-icons-spare" style="cursor:pointer;" (click)="openLabourEditSidebar(quote)">edit</i>
                    </div>
            
                    <!-- <span class="date" style="text-align: end;">₹{{quote.labourAmount * quote.quantity | number:'1.0-0'}}</span>
             -->
                    <span class="date" style="text-align: end;">₹{{quote.labourAmount * quote.quantity | number:'1.0-0'}}</span>

                  </div>
                  <div class="lines">
                    <span *ngIf="labourItemsCount > 0" class="date-time">{{quote.edt  | date:'dd MMM yyyy'}}</span>
                  </div>
                  <hr style="border: 1px solid #ebebeb;" />
                  
                  
                  <div class="quantity-control">
                    <div class="brand">
                      {{quote.brand}}
                    </div>
                    <div class="addtocartcompatiblecar1">
                      <div class="spare-add-cart1">
                          <!-- <div class="btn-group"> -->
                              <button class="button1" mat-raised-button style="font-size: 11px; float: left; width: 25%; min-width: 25%; box-shadow: none; padding: 0; margin: 0; line-height: 36px; border-top-left-radius: 10px; border-bottom-left-radius: 10px;" (click)="decrementLabourQuantity(quote)">
                                  <mat-icon class="sidebuttons1" style="width: 1px; padding: 7px 0px; margin-left: -6px; margin-right: -3px; font-size: 18px; height: 35px; vertical-align: center; color: #144579;">remove</mat-icon>
                              </button>
                              <span class="button1" mat-raised-button style="font-size: 13px; float: left; width: 50%; text-align: center; color: #144579; line-height: 36px;">
                                {{quote.quantity}} 
                              </span>
                              <button class="button1" mat-raised-button style="font-size: 11px; float: left; width: 25%; min-width: 25%; box-shadow: none; padding: 0; margin: 0; line-height: 36px; border-top-right-radius: 10px; border-bottom-right-radius: 10px;" (click)="incrementLabourQuantity(quote)" >
                                <mat-icon class="sidebutton1" style="width: 1px; padding: 7px 0px; margin-left: -6px; margin-right: -3px; font-size: 18px; height: 35px; vertical-align: center; color: #144579;">add</mat-icon>
                              </button>
                          <!-- </div> -->
                      </div>
                  </div>
                    <!-- <div class="add-minus">
                      <button mat-icon-button (click)="decrementjobcardQuantity(quote)">
                        <mat-icon style="margin-right: 6px;">remove</mat-icon>
                      </button>
                      <span style="padding: 7px;margin-left: 12px;">{{ quote.itemQuantity }}</span>
                      <button mat-icon-button (click)="incrementjobcardQuantity(quote)">
                        <mat-icon>add</mat-icon>
                      </button>
                  </div> -->
                  </div>

                </div>
                            <!-- Discount section above the CTA -->
          <div *ngIf="calculatedDiscount > 0" class="discount-info-container">
            <div class="discount-label">
                <div  class="percent-badge">%</div>
                <div  style="display: inline; margin-left: 10px;">
                  <span style="color: lightslategrey;">Discount</span>
                  <div style="color: black;font-weight: 700;">₹{{ calculatedDiscount | number:'1.2-2' }}</div>
                </div>
            </div>
            <div class="discount-amount">
              <span class="change-link" (click)="openExtraDiscountBottomSheet()">Change</span>
            </div>
          </div>
          <div *ngIf="calculatedDiscount === 0 && anyItemSelectedQuote()" class="extra-discount-div"(click)="openExtraDiscountBottomSheet()">
            <div class="percent-badge">%</div>
            <button class="extra-discount-btn" type="button">Add Extra Discount</button> 
          </div>
          <!--Discount  Bottom Sheet -->
          <div class="overlay" [class.visible]="showExtraDiscountBottomSheet" (click)="closePopup()"></div>
            <div class="extra-discount-bottom-sheet" *ngIf="showExtraDiscountBottomSheet && anyItemSelectedQuote()">
              <div class="sheet-header">
                <div class="discount-add-text">Add Extra Discount</div>
                <div class="info-material-icon" (click)="toggleInfoPopup()">
                  <mat-icon>info</mat-icon>
                </div>
                  <div><mat-icon  (click)="closeExtraDiscountBottomSheet()">close</mat-icon></div>
              </div>

              <div class="enter-discount-text">Enter Discount In</div>
              <div class="toggle-radio-buttons">
                <label >
                  <input
                    type="radio"
                    name="discountType"
                    value="rupees"
                   
                  />
                  <span style="color: black; font-weight: 700;">₹</span>
                </label>
              
                <label>
                  <input
                    type="radio"
                    name="discountType"
                    value="percentage"
                   
                  />
                  <span  style="color: black;">%</span>
                </label>
              </div>
              
              <div class="percent-tab">
                <mat-form-field appearance="outline" class="discount-input-field" style="padding: 0px !important;">
                  <mat-label>Discount in {{ discountType === 'rupees' ? '₹' : '%' }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [(ngModel)]="discountValue"
                    (input)="calculateDiscountPreview(i)" />
                </mat-form-field>
                <mat-error *ngIf="isDiscountInvalid">
                  Discount cannot be greater than {{totalSelectedPriceQuote123 }}.
                </mat-error>
                
              </div>
              
              <div class="dis-and-save">
                <div *ngIf="discountValue > 0" class="discount-preview">
                  <div class="discount-rupees-cal"> ₹ {{ getDiscountAmount() | number:'1.2-2' }} ({{ getDiscountPercentage() | number:'1.2-2' }}% )</div>
                  <div>(Discount will be applied)</div>
                </div>        
                <!-- <div class="save-btn-tab">
                  <button class="save-btn" (click)="saveExtraDiscount()">Save</button>
                </div> -->
                <div class="save-btn-tab" >
                  <button class="save-btn"  [disabled]="isDiscountInvalid" (click)="saveExtraDiscount()">Save</button>
                </div>
              </div>
              
            </div>
            <!-- Info Popup -->
            <div class="overlay" [class.visible]="showInfoPopup" (click)="closePopup()"></div>
              <div class="info-popup" *ngIf="showInfoPopup">
                <div class="popup-header">
                  <span class="popup-title">Extra Discount</span>
                  <mat-icon class="popup-close-icon" (click)="toggleInfoPopup()">close</mat-icon>
                </div>
                <div class="popup-message">
                  Extra discount is directly deducted to the total invoice amount. It does not affect the tax calculations.
                </div>
                <div class="popup-footer">
                  <button class="popup-ok-btn" (click)="toggleInfoPopup()">Okay</button>
                </div>
              </div>
              </div>
              <div class="labour-section-details">
                <div class="image-header-title">
                  <h2 style="font-weight: bold;">Images</h2>
                    <div class="fuel-image-upload" *ngIf = "(customerQuotation?.length > 0 || selectedItemsLabourQuote?.length > 0)">
                    <button class="add-image-btn" (click)="fileInput.click()" style="margin-top: 15px;">
                      <mat-icon style="font-size: 15px;padding: 3px;">add_a_photo</mat-icon> ADD IMAGES
                     <!-- <p style="margin-top:23px;color:#144579;cursor:pointer;font-weight: bold;" (click)="addLabourSidebar()" >Add Images</p> -->
               
                    </button>
                    
                    <input
                    type="file"
                    #fileInput
                    (change)="onFileSelected($event)"
                    accept="image/*"
                    multiple
                    style="display: none;"
                  />
                  </div>
                </div>

                <div class="image-wrapper" *ngFor="let image of newlyUploadedImages; let i = index">
                
                  <img [src]="image.url" alt="Selected Image" class="image-preview" (click)="openViewer(i)">
                  <span style="margin-left: 21px;margin-bottom: 5px;">{{image.tag}}</span>
                  <button mat-icon-button class="delete-icon" style="border: none; background-color: #ffff;" (click)="deleteQuoteImage(i)">
                    <mat-icon style="margin-top: -2px;margin-left: -10px;background-color: #ffff;border-radius: 20px;" color="warn">close</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="calculatedDiscount > 0" class="discount-info-container">
              <div class="discount-label">
                  <div  class="percent-badge">%</div>
                  <div  style="display: inline; margin-left: 10px;">
                    <span style="color: lightslategrey;">Discount</span>
                    <div style="color: black;font-weight: 700;">₹{{ calculatedDiscount | number:'1.2-2' }}</div>
                  </div>
              </div>
              <div class="discount-amount">
                <span class="change-link" (click)="openExtraDiscountBottomSheet()">Change</span>
              </div>
            </div>
            <div *ngIf="calculatedDiscount === 0 && anyItemSelectedQuote()" class="extra-discount-div"(click)="openExtraDiscountBottomSheet()">
              <div class="percent-badge">%</div>
              <button class="extra-discount-btn" type="button">Add Extra Discount</button> 
            </div>
            <!--Discount  Bottom Sheet -->
            <div class="overlay" [class.visible]="showExtraDiscountBottomSheet" (click)="closePopup()"></div>
              <div class="extra-discount-bottom-sheet" *ngIf="showExtraDiscountBottomSheet && anyItemSelectedQuote()">
                <div class="sheet-header">
                  <div class="discount-add-text">Add Extra Discount</div>
                  <div class="info-material-icon" (click)="toggleInfoPopup()" style=" width: 41%;">
                    <mat-icon>info</mat-icon>
                  </div>
                    <div><mat-icon  (click)="closeExtraDiscountBottomSheet()">close</mat-icon></div>
                </div>
  
                <div class="enter-discount-text">Enter Discount In</div>
                <div class="toggle-radio-buttons">
                  <label >
                    <input
                      type="radio"
                      name="discountType"
                      value="rupees"
                      [(ngModel)]="discountType"
                    />
                    <span style="color: black; font-weight: 700;">₹</span>
                  </label>
                
                  <label>
                    <input
                      type="radio"
                      name="discountType"
                      value="percentage"
                      [(ngModel)]="discountType"
                    />
                    <span  style="color: black;">%</span>
                  </label>
                </div>
                
                <div class="percent-tab">
                  <mat-form-field appearance="outline" class="discount-input-field" style="padding: 0px !important;">
                    <mat-label>Discount in {{ discountType === 'rupees' ? '₹' : '%' }}</mat-label>
                    <input
                      matInput
                      type="number"
                      [(ngModel)]="discountValue"
                      (input)="calculateDiscountPreview(i)" />
                  </mat-form-field>
                  <mat-error *ngIf="isDiscountInvalid">
                    Discount cannot be greater than {{totalSelectedPriceQuote123 }}.
                  </mat-error>
                  
                </div>
                
                <div class="dis-and-save">
                  <div *ngIf="discountValue > 0" class="discount-preview">
                    <div class="discount-rupees-cal"> ₹ {{ getDiscountAmount() | number:'1.2-2' }} ({{ getDiscountPercentage() | number:'1.2-2' }}% )</div>
                    <div>(Discount will be applied)</div>
                  </div>        
                  <!-- <div class="save-btn-tab">
                    <button class="save-btn" (click)="saveExtraDiscount()">Save</button>
                  </div> -->
                  <div class="save-btn-tab" >
                    <button class="save-btn"  [disabled]="isDiscountInvalid" (click)="saveExtraDiscount()">Save</button>
                  </div>
                </div>
                
              </div>
              <!-- Info Popup -->
              <div class="overlay" [class.visible]="showInfoPopup" (click)="closePopup()"></div>
                <div class="info-popup-new" *ngIf="showInfoPopup">
                  <div class="popup-header">
                    <span class="popup-title">Extra Discount</span>
                    <mat-icon class="popup-close-icon" (click)="toggleInfoPopup()">close</mat-icon>
                  </div>
                  <div class="popup-message">
                    Extra discount is directly deducted to the total invoice amount. It does not affect the tax calculations.
                  </div>
                  <div class="popup-footer">
                    <button class="popup-ok-btn" (click)="toggleInfoPopup()">Okay</button>
                  </div>
                </div>
            <ng-template #noQuotesReceived>
              <div>
                  <div class="empty-state">
                    <img src="../../../../assets/images/request-details images/requestdetailsimage.png" alt="Quote Not Created" class="quote-image">
                    <div class="message">
                      <strong>Quote Not Created Yet!</strong>
                      <p>Create Customer Quotation.</p>
                    </div>
                  </div>
              </div>
            </ng-template> 
          </div>

        <div *ngIf="(customerQuotation?.length > 0 && selectedItemsLabourQuote?.length == 0)" class="floater-btn" (click)="AddItems()">
          <p style="font-weight: bold;">ADD ITEM</p>
        </div>
        <!-- Add Item Side Bar -->
        <div *ngIf="isSidebarOpen" class="new-sidebar">
          <div class="header1" style="margin-left: 3px;">
            <div class="maticon" style="margin-left: 3px;">
            <mat-icon style="margin-left: 3px;" (click)="toggleSidebar()" >arrow_back</mat-icon>
          </div>
          <div class="add-items">
            <h3 style="font-weight: bold;margin-bottom:20px;float:left;">Add Items</h3>
          </div>
          </div>
          <div class="search-bar">
            <input
              type="text"
              placeholder="Search by Part Name"
              [(ngModel)]="searchWord"
              class="search-input"
              (input)="onSearch()"
            />
            <button *ngIf="searchWord" class="clear-btn" (click)="clearSearch()">&#x2715;</button>
          </div>
          
          <div class="item-list">
            <div *ngFor="let item of filteredItems" class="dropdown-item" (click)="addItemToQuotation(item)">
              <img [src]="item.imageUrl" alt="{{ item.partName }}" class="dropdown-image" />
              <div class="dropdown-details" style="width: 100%;">
                <h4>{{ item.name }}</h4>
                <p>Brand: {{ item.brand }}</p>
                <div class="item-price1">
                  <p>₹{{item.mrp }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cantFind" (click)="createNewItems()" >
            <p>Can't Find Your Item?</p>
            <button mat-icon-button class="arrow-button">
              <mat-icon style="font-size: 15px;color: #ffff;" class="arrow_forward">arrow_forward</mat-icon>
            </button>
          </div>
          
        </div>
        
        <div class="overlay" [class.visible]="newItem" (click)="createNewItems()" ></div>
        <div class="custom-sidebar" *ngIf="newItem">
          <button mat-icon-button class="back-buttonNew" (click)="createNewItems()" >
            <mat-icon>arrow_back</mat-icon>
          </button>
        
          <div class="content">
            <div class="image-container">
              <img  src="../../../../assets/images/car-repair.png" alt="car-repair">
            </div>
            
            <p class="title">Can't find what you are looking for?</p>
            <p class="subtitle" *ngIf="searchWord.length>0">Create {{searchWord}}</p>
            
          </div>
          <div class="fixedCTA">
            <button mat-button class="primary-btn" (click)="createItemSidebar()">CREATE ITEM</button>
          </div>
        </div>

      

        <!-- Add Labour -->
        <div *ngIf="isAddLabour" class="labour-sidebar">
         <div class="labour-section">
            <div class="labour-maticon" style="width: 12%;">
              <mat-icon (click)="labourRedirectSidebar()">arrow_back</mat-icon>
            </div>
            <div class="labour-header" >
              <h2 style="font-weight:600;">Add Labour</h2>
            </div>
            <div class="labour-skip" >
              <p style="position: relative;float:right;padding:10px;cursor:pointer;color:#144579;"(click)="openSkipConfirmation()">Skip</p>
            </div>
          </div>
          <div class="search-bar">
            <input
              type="text"
              placeholder="Search Labour"
              [(ngModel)]="searchText"
              class="search-input"
              (input)="onLabourSearch()"/>
      
            <button *ngIf="searchText" class="clear-btn" (click)="clearLabourSearch()">&#x2715;</button>
          </div>
          <div class="item-list1">
          <!-- Labour List -->
          <div *ngFor="let labour of labourListData" class="dropdown-item">
            <div class="checkboxselect">
              <input 
                type="checkbox" 
                [(ngModel)]="labour.selected" 
                (change)="onLabourSelectionChange(labour)"
              />
            </div>
            <div class="dropdown-details" style="margin-left: 20px;">
              <h4>{{ labour.labourName }}</h4>
              <div class="item-price">
                <p>₹{{ labour.labourAmount }}</p>
              </div>

            </div>
            <div class="edit-btn" >
              <i class="material-icons" (click)="openLabourEditSidebar(labour)">edit</i>
            </div>
          </div>
          
            <div class="floater-labour-btn" (click)="openLabourEditSidebar()">
              <p>ADD LABOUR</p>
            </div>
        </div>
            <!-- Skip Confirmation Popup -->
            <div class="skip-confirmation" *ngIf="showSkipConfirmation">
              <!-- <button class="cancel-popup-close" (click)="closeSkipConfirmation()">×</button> -->
              <p class="skip-text">Are you sure you want to skip Adding Labour?</p>
              <button class="cancel-popup-btn no-btn" (click)="closeSkipConfirmation()">No</button>
              <button class="cancel-popup-btn confirm-btn" (click)="openPopup()">Yes</button>
              
          </div>
          <!-- labour bottom CTA -->
          <div 
              *ngIf="selectedLabourslength > 0 || labourCount > 0" 
              [ngClass]="isMobile?'bottom-boxQuoteMobile':'bottom-boxQuote'">
                <div class="bottom-contentQuote" style="display: flex;gap: 29px;">
                  <div class="total-items">{{ selectedLaboursNewCount }} items
                    <p class="total-amount">₹{{totalSelectedPriceQuote1 | number:'1.0-0' }}</p>
                  
                  </div>
                  <button type="button" class="add-labour-bottom-cta" style="height: 38px;" (click)="toggleSelectItem()">Add Labour</button>
                  
              </div>
          </div>
        </div>
        
        <div *ngIf="customerQuotationListCount==0 || customerQuotationListCount == null" (click)="AddItems()" class="add-quote-items" >
          <button class="quotation-bottom-cta">Add Quote Items</button>
        </div>

        <!-- customer quote bottom CTA -->
        <div *ngIf="anyItemSelectedQuote() || anyItemSelected() || selectedItemsCountQuote>0 " [ngClass]="isMobile ? 'bottom-boxQuoteMobile':'bottom-boxQuote'">
        <!-- <div *ngIf="anyItemSelectedQuote() && customerQuotation?.length>0 && !selectedItemsLabourQuote" [ngClass]="isMobile ? 'bottom-boxQuoteMobile':'bottom-boxQuote'"> -->
            <div class="bottom-contentQuote">
              <div class="total-items">{{selectedItemsCount}} items
                <p class="total-amount">₹{{totalSelectedPriceQuote - calculatedDiscount | number:'1.0-0'}}</p>
                <!-- <p *ngIf="activeTab === 'quote-approved'" class="total-amount">₹{{quoteApprovedPrice | number:'1.2-2' }}</p> -->
              </div>
              <div class="update-quote-btn2">
              <button class="add-labour-bottom-btn1" 
                *ngIf="totalSelectedPriceQuote > 0 && (selectedLabourslength == 0 || selectedLabourslength == null || selectedLabourslength == '')" 
                type="button" 
                (click)="addLabourSidebar()">
                Add Labour
                <span class="next-step-text">(In Next Step)</span>
              </button>
              </div>
            </div>  
        </div>
        

        <div *ngIf="(anyItemSelectedQuote() || anyItemSelected()) && customerQuotation?.length>0 && selectedItemsLabourQuote?.length>0" [ngClass]="isMobile ? 'bottom-boxQuoteMobile':'bottom-boxQuote'">
          <div class="bottom-contentQuote">
            <div class="total-items">{{selectedItemsCount}} items
              <p class="total-amount">₹{{ (totalSelectedPriceQuote123- calculatedDiscount) | number:'1.0-0'}}</p>
              <!-- <p *ngIf="activeTab === 'quote-approved'" class="total-amount">₹{{quoteApprovedPrice | number:'1.2-2' }}</p> -->
            </div>
            <div class="update-quote-btn-create2">
            <button class="create-quote-btn"  type="button" 
              (click)="openPopup()" >Create Customer Quote</button>
            </div>
          </div> 
          <!-- <div class="update-quote-btn2">
            <button class="create-quote-btn"  type="button" 
              (click)="openPopup()">Update Customer Quote</button>
          </div>
        </div>    -->
      </div>

        <!-- Edit labour name Sidebar -->
        <div class="overlay1" [class.visible]="isEditLabourSidebarOpen" (click)="closeLabourEditSidebar()"></div>
        <div *ngIf="isEditLabourSidebarOpen" class="edit-labour-sidebar">
          <div class="labour-sidebar-header">
            <h2>{{ selectedLabour?.id ? 'Edit Labour' : 'Add Labour' }}</h2>
            <mat-icon (click)="closeLabourEditSidebar()">close</mat-icon>
          </div>
        
          <form [formGroup]="laborDetails" class="labour-details">
            <div class="labour-name-column">
              <mat-form-field appearance="outline" class="full-width" style="margin-top: 10px;width:100%">
                <mat-label>Labour Name</mat-label>
                <input
                  matInput
                  formControlName="labourName"
                  [(ngModel)]="selectedLabour.labourName"
                  placeholder="Enter Labour Name"
                  name="labourName"
                />
              </mat-form-field>
            </div>
        
            <div class="labour-name-column" >
              <mat-form-field appearance="outline" class="full-width" style="margin-top: 10px;width:100%">
                <mat-label>Labour Amount</mat-label>
                <input
                  matInput
                  formControlName="labourAmount"
                  [(ngModel)]="selectedLabour.labourAmount"
                  placeholder="Enter Labour Amount"
                  name="labourPrice"
                />
              </mat-form-field>
            </div>
          </form>
        
          <div class="item-update" style="margin-top: -14px;">
            <button class="item-update-btn" *ngIf="selectedLabour?.id" (click)="saveLabour()">Save Labour</button>
            <button class="item-update-btn" *ngIf="!selectedLabour?.id" (click)="addLabour()">Add Labour</button>
          </div>
        </div>

        <!-- Popup for skip labour -->
          <!-- <div class="cancel-popup-container" *ngIf="showCancelConfirmation">
            <div class="cancel-popup">
              <button class="cancel-popup-close" (click)="closeCancelPopup()">×</button>
              <p>Are you sure you want to skip?</p>
              <button class="cancel-popup-btn confirm-btn" (click)="confirmAction()">Yes</button>
              <button class="cancel-popup-btn no-btn" (click)="closeCancelPopup()">No</button>
            </div>
          </div> -->
    </mat-list>
  
  </div>
  <div class="overlay" [class.visible]="newItems" (click)="createItemSidebar()" ></div>
        <mat-sidenav-container class="sidebar-containerNew" *ngIf="newItems">
          <mat-sidenav #sidenav mode="side" class="custom-sidebar" [(opened)]="newItems">
            <!-- <div class="sidebar-header">
              <mat-icon (click)="newItems = false">arrow_back</mat-icon>
              <h3>Create Item</h3>
            </div> -->
            <div class="sidebar-header">
              <div *ngIf="!searchActive" class="header-normal">
                <mat-icon (click)="newItems = false">arrow_back</mat-icon>
                <h3>Create Item</h3>
                <mat-icon class="search-toggle" (click)="toggleTopSearchBar()">search</mat-icon>
              </div>
              <div *ngIf="searchActive" class="header-search">
                <div class="search-container">
                  <mat-icon class="search-icon">search</mat-icon>
                  <input type="text" placeholder="Search..."  class="search-input-new"
                      [(ngModel)]="searchText"
                      (input)="filterSuggestions()" />
                  <mat-icon class="close-icon1" (click)="toggleTopSearchBar()">close</mat-icon>
                   <!-- 🟨 Suggestion Dropdown -->
                <ul class="suggestion-list" *ngIf="suggestions.length > 0">
                  <li *ngFor="let item of suggestions" (click)="onPartSelected(item.type === 'partNumber' ? item.value : null)">
                    {{ item.value }}
                  </li>
                </ul>
                </div>
              </div>
            </div>
            <div class="sidebar-content">
              <form [formGroup]="itemForm" (ngSubmit)="onSubmit()">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item Name *</mat-label>
                  <input matInput formControlName="itemName" (input)="onItemNameInput($event.target.value)" (blur)="hideSuggestions()"
                    (focus)="showSuggestions()"
                    autocomplete="off" >
                  <mat-error *ngIf="itemForm.get('itemName')?.invalid && itemForm.get('itemName')?.touched">
                    Item Name is required
                  </mat-error>
                  <!-- Suggestions dropdown -->
                    <div
                      *ngIf="showSuggestionList && itemSuggestions.length > 0"
                      class="suggestions-dropdown"
                    >
                      <div
                        class="suggestion-item"
                        *ngFor="let item of itemSuggestions"
                        (mousedown)="selectItem(item)"
                      >
                        {{ item.name }}
                      </div>
                    </div>
                </mat-form-field>
              
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Part Number *</mat-label>
                  <input matInput formControlName="partNumber">
                  <mat-error *ngIf="itemForm.get('partNumber')?.invalid && itemForm.get('partNumber')?.touched">
                    Part Number is required
                  </mat-error>
                </mat-form-field>
              
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Brand *</mat-label>
                  <input matInput formControlName="brand">
                  <mat-error *ngIf="itemForm.get('brand')?.invalid && itemForm.get('brand')?.touched">
                    Brand is required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>GST% *</mat-label>
                  <mat-select formControlName="gst">
                    <mat-select [(value)]="selectedGst">
                      <mat-option *ngFor="let gst of gstOptions" [value]="gst">
                        GST {{ gst }}%
                      </mat-option>
                    </mat-select>
                  </mat-select>
                  <mat-error *ngIf="itemForm.get('gst')?.invalid && itemForm.get('gst')?.touched">
                    Select GST%
                  </mat-error>
                </mat-form-field>
              
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>HSN *</mat-label>
                  <input matInput formControlName="hsn" >
                  <mat-error *ngIf="itemForm.get('hsn')?.invalid && itemForm.get('hsn')?.touched">
                    Enter a valid HSN (4-8 digits)
                  </mat-error>
                </mat-form-field>
              
            
                <mat-form-field appearance="outline" class="full-width" style="margin-bottom: 128px;">
                  <mat-label>Unit Price *</mat-label>
                  <input matInput formControlName="unitPrice">
                  <mat-error *ngIf="itemForm.get('unitPrice')?.invalid && itemForm.get('unitPrice')?.touched">
                    Enter a valid Unit Price 
                  </mat-error>
                </mat-form-field>
                <div class="fixedCTA" style="width: 29.5%;right: 18px;" >
                <button mat-flat-button color="primary" class="primary-btn" type="submit" >
                  Create Item
                </button>
              </div>
              </form>
            </div>
          </mat-sidenav>
        </mat-sidenav-container>

</mat-sidenav-container>

<!-- Popup content -->
<div *ngIf="isPopupOpen" class="popup">
  <div class="popup-content">
    <mat-icon (click)="closePopup()" style="float: right; cursor: pointer;">close</mat-icon>
    <img src="{{successIcon}}" alt="successIcon" style="width: 36%;">
    <h3>Quote Created</h3>
        
    <p class="order-label">
      <span class="order-id">Quotation id 
        <span [ngStyle]="{ 'color': '#144579', 'font-weight': 'bold' }">{{ resData?.id }}</span>
      </span>
    </p>
    
    <p class="date"><span>{{resData?.placedOn | date:'dd MMM yyyy, hh:mm a'}}</span></p>
    <p class="thank you">You have successfully created quotation</p>

    <button class="goto-order" (click)="closeViewDetails()">View Customer Quote</button>
  </div>
</div>

<!-- ===============================code for request tab in jobcard-details page==================================== -->
<div *ngIf="isRquestSidebarOpen" class="page-layout blank fullwidth p-12" fusePerfectScrollbar style="height: 1px; overflow-y: scroll; margin-bottom: 5em;    top: 1px;">

  <div class="overlay" [class.visible]="isRquestSidebarOpen" (click)="closeSidebarRequest()"></div>
  <div *ngIf="isRquestSidebarOpen" class="sidebar-addItems-request">
    <div class="header-request">
      <mat-icon (click)="closeSidebarRequest()"  class="headerclosebutton">keyboard_backspace</mat-icon>
      <h2>Enter Item List</h2>
      <button *ngIf="spareRequestId" class="view-rqst-btn" (click)="viewRequest()">
        View Request
      </button>
      <mat-icon  (click)="closeSidebarRequest()" class="headerclosebutton">close</mat-icon>
    </div>
    <div class="newclick-addItems-request">Enter item names separated by commas or in separate lines.
      <div class="strong1"> Click <strong>'Enter'</strong> when done. </div></div>
    <!-- <textarea [(ngModel)]="itemList" rows="20" placeholder="Enter items here..."></textarea> -->
    <div class="matformfieldnew1">
        <mat-form-field appearance="outline" style="width: 100%;">
        <!-- <mat-form-field  class="custom-mat        -form-field"> -->
          <!-- <div class="custom-textarea-container"> -->
            <mat-label>Enter items here</mat-label>
            <textarea matInput [(ngModel)]="itemList" rows="15" style="text-align: left;"></textarea>
          <!-- </div> -->
        </mat-form-field>   
    </div> 
    <div class="enterbutton">
      <button class="cta-btn" (click)="createRequest()">Enter</button>
    </div>
    <p *ngIf="showError" class="Error-new" style="color: red;">Please enter at least one item name to proceed.</p>
  </div>

</div>

<!-- Popup Section -->
<div class="overlay-request" [class.visible]="isRequestPopupVisible" (click)="closeRequestPopup()"></div>
<div *ngIf="isRequestPopupVisible" class="modal-overlay">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <img src="{{successIcon}}" alt="Success Icon" class="success-icon">
      <h2>Request Created!</h2>
      <button class="close-modal" (click)="closeRequestPopup()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <p>Request ID: <span class="request-id">{{spareRequestId}}</span></p>
      <p>Date <span class="createdAt1">{{spareRequestCreated | date:'dd MMM yyyy, hh:mm a'}}
      </span></p>
      <p>Let us deliver an awesome experience!</p>
    </div>
    <div class="modal-footer">
      <button class="view-request-btn" (click)="viewRequest()">View Request</button>
    </div>
  </div>
</div>
<div #createQuotationContainer style="width: 100%;"></div>